import { Container } from '../ui/Container'
import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react'

const footerNavigation = {
  services: [
    { name: 'Penerbitan', href: '/penerbitan' },
    { name: 'Konversi KTI', href: '/konversi-kti' },
    { name: 'Pra Cetak', href: '/pra-cetak' },
    { name: 'Jasa Cetak', href: '/jasa-cetak' },
  ],
}

const partners = [
  { src: "/mitra/perpus.png", alt: "Perpusnas", height: "h-14" },
  { src: "/mitra/ikapi.png", alt: "IKAPI", height: "h-14" },
  { src: "/mitra/gramedia.png", alt: "Gramedia", height: "h-14" },
  { src: "/mitra/play-books.png", alt: "Google Play Books", height: "h-18" },
  { src: "/mitra/scholar.png", alt: "Google Scholar", height: "h-18" },
]

export default function Footer() {
  return (
    <footer className="bg-white border-t border-slate-100">
      <Container>
        <div className="py-16">
          {/* Main Grid: Menggunakan gap yang konsisten daripada margin-left manual */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">

            {/* 1. Company Info */}
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <img src='/logo-pranala.png' alt='Logo' className="w-10 h-10 object-contain" />
                <span className="font-bold tracking-tight text-slate-900 text-lg">
                  PUSTAKA PRANALA
                </span>
              </div>
              <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
                Pustaka Pranala adalah penerbit yang menghadirkan buku pendidikan, buku ajar, referensi akademik, monograf, karya fiksi, dan buku anak melalui publikasi cetak dan digital, serta ditopang oleh fasilitas percetakan internal berstandar kualitas tinggi.
              </p>
              <div className="flex gap-4 text-slate-400">
                <a href="https://www.instagram.com/pustakapranala" className="hover:text-brand-yellow-600 transition-colors">
                  <img src='/instagram.webp' alt='logo-instagram' className="w-7 h-7" />
                </a>
                <a href="https://www.facebook.com/profile.php?id=61575624133900" className="hover:text-brand-yellow-600 transition-colors">
                  <img src='/facebook.webp' alt='logo-facebook' className="w-7 h-7" />
                </a>
                <a href="https://www.tiktok.com/@pustaka.pranala" className="hover:text-brand-yellow-600 transition-colors">
                  <img src='/tiktok-logo.webp' alt='Logo-tiktok' className="w-7 h-7 object-contain" />
                </a>
                <a href="https://shopee.co.id/bukubaikpustaka99" className="hover:text-brand-yellow-600 transition-colors">
                  <img src='/shopee.webp' alt='Logo-shopee' className="w-7 h-7 object-contain" />
                </a>
              </div>
            </div>

            <div className='ml-6 mt-2' >
              <h4 className="font-semibold text-slate-900 mb-6 text-sm uppercase tracking-wider">Layanan</h4>
              <ul className="space-y-4">
                {footerNavigation.services.map((item) => (
                  <li key={item.name}>
                    <a href={item.href} className="text-sm text-slate-500 hover:text-brand-yellow-600 transition-colors">
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* 3. Kemitraan - Dibuat Flexbox agar lebih rapi secara visual */}
            <div>
              <h4 className="font-semibold text-slate-900 mb-6 text-sm uppercase tracking-wider">Kemitraan</h4>
              <div className="flex flex-wrap gap-14 items-center">
                {partners.map((partner) => (
                  <img
                    key={partner.alt}
                    src={partner.src}
                    alt={partner.alt}
                    className={`${partner.height} w-auto opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300 object-contain`}
                  />
                ))}
              </div>
            </div>

            {/* 4. Newsletter & Contact */}
            <div className="space-y-8">
              <div>
                <h4 className="font-semibold text-slate-900 mb-4 text-sm uppercase tracking-wider">Newsletter</h4>
                <div className="relative group">
                  <input
                    type="email"
                    placeholder="Email Anda"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-yellow-400/20 focus:border-brand-yellow-400 transition-all"
                  />
                  <button className="absolute right-2 top-2 bg-slate-900 text-white p-1.5 rounded-lg hover:bg-slate-800 transition-colors">
                    <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </div>

              <div className="space-y-3">
                <div className="flex items-center text-sm text-slate-500 gap-3">
                  <Phone className="w-4 h-4 text-brand-yellow-500" />
                  <span>0851-2441-3535</span>
                </div>
                <div className="flex items-center text-sm text-slate-500 gap-3">
                  <Mail className="w-4 h-4 text-brand-yellow-500" />
                  <span className="break-all">penerbit.pustakapranala@gmail.com</span>
                </div>
                <div className="flex items-start text-sm text-slate-500 gap-3">
                  <MapPin className="w-4 h-4 text-brand-yellow-500 shrink-0 mt-1" />
                  <span className="leading-tight">Jl. Rejowinangun No.66, Kotagede, Yogyakarta</span>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-slate-100 py-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-slate-400">
            &copy; {new Date().getFullYear()} Pustaka Pranala. All rights reserved.
          </p>
          <div className="flex gap-8">
            <a href="/privacy" className="text-xs text-slate-400 hover:text-slate-600 transition-colors">Privacy Policy</a>
            <a href="/terms" className="text-xs text-slate-400 hover:text-slate-600 transition-colors">Terms of Service</a>
          </div>
        </div>
      </Container>
    </footer>
  )
}
